import { SETTLEMENT_TYPE } from 'api/data/constants';
import { IBaseGist, TObject } from 'utils/types';

import {
  IPspTerminal,
  IPspTerminalParameter,
  ITerminalData,
  ITerminalParam,
} from './types';

const normalizePspParams = (data: TObject): ITerminalParam => {
  return {
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    type: (data?.type as string) || '',
    value: (data?.value as string) || '',
  };
};

export const normalizeTerminals = (data: ITerminalData): IPspTerminal => {
  return {
    bank: {
      id: (data?.bank?.id as number) || 0,
      name: (data?.bank?.name as string) || '',
    },
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    parameters: data?.parameters?.map(normalizePspParams) || [],
    settlementType: (data?.settlementType as SETTLEMENT_TYPE[]) || [],
  };
};

export const normalizeCreatedTerminal = (data: TObject): IBaseGist => {
  return {
    id: (data?.id as number) || 0,
  };
};

export const normalizeTerminalParameter = (data: TObject) => {
  return {
    comment: (data?.comment as string) || '',
    defaultValue: (data?.defaultValue as string) || '',
    editable: !!data?.editable,
    id: data?.id as number,
    level: (data?.level as string) || '',
    name: (data?.name as string) || '',
    paramId: data?.paramId as number,
    type: (data?.type as string) || '',
    value: (data?.value as string) || '',
  };
};

export const normalizePspTerminalParameters = (
  data: TObject[],
): IPspTerminalParameter[] => {
  return data?.map(normalizeTerminalParameter) || [];
};
